import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductPlanFormModelContext } from "../../../../../context";

export const usePlanAvailableDiscountIDs = () => {
	const { viewModel, onSetViewModel, queryData } = useProductPlanFormModelContext();
	const { availableDiscountIDs } = viewModel;
	const { discountNameAndIDOptions } = queryData.connection;

	return useConnection<"availableDiscountIDs">({
		availableItemIDs: availableDiscountIDs, //
		nameAndIDOptions: discountNameAndIDOptions,
		keyOfValue: "availableDiscountIDs",
		onSetViewModel,
	});
};
